﻿(function (document) {

    function EnsureScreenSnapIsSet() {
        if (window.scrollY > 0) {
            document.querySelector('body').classList.remove('screen-top-snap');
        } else {
            document.querySelector('body').classList.add('screen-top-snap');
        }
    }

    document.addEventListener('DOMContentLoaded', function (e) {
        EnsureScreenSnapIsSet();
    });

    window.addEventListener('resize', function () {
        EnsureScreenSnapIsSet();
    });

    window.addEventListener('scroll', function () {
        EnsureScreenSnapIsSet();
    });
})(document);